// extracted by mini-css-extract-plugin
export default {"chip":"MGChip_chip__QYac3","label":"MGChip_label__5IhZU","iconLeft":"MGChip_iconLeft__UXMj3","iconRight":"MGChip_iconRight__7EAiF"};